export const Colors = {
  BackgroundGray: "#404040",
  White: "#FEFEFE",
  Black: "#000000",
  DarkGray: "#1E1E1E",
  Gray: "#C4C4C4",
  LightGray: "#A5A1A1",
  LighterGray: "#F0F0F0",
  ConfirmBlue: "#0B6A99",
  WarningYellow: "#F5D531",
  CancelRed: "#F64932",
  DocsBlue: "#a4c2f4",
  DocsGreen: "#b6d7a8",
  DocsYellow: "#ffe599",
  DocsOrange: "#f6b26b",
  DocsHighlight: "#a5a5a5",
};